import { linhasRelatorio, rotuloColuna } from '../../lib/relatorios/exportacao';

const METRICAS: Record<string,string> = { A02:'ocupacaoPct',A03:'pecasPorHora',A04:'pecasBoas',A05:'aderenciaPct',A06:'qtdRefugoTotal',R10:'oeePct' };

export function RelatorioResumo({codigo,resultado}:{codigo:string;resultado:unknown}) {
  const metrica=METRICAS[codigo];
  if(!metrica) return null;
  const linhas=linhasRelatorio(resultado).filter(r=>typeof r[metrica]==='number').slice(0,12);
  if(!linhas.length) return null;
  const teto=metrica.endsWith('Pct')?100:Math.max(1,...linhas.map(r=>Number(r[metrica])));
  return <figure className="rounded-xl border bg-surface p-5 space-y-4">
    <figcaption className="flex flex-wrap items-baseline justify-between gap-2"><span className="font-semibold">{rotuloColuna(metrica)}</span><span className="text-xs text-muted-foreground">{linhas.length} resultados · detalhamento na tabela</span></figcaption>
    <div className="grid gap-3 sm:grid-cols-2">{linhas.map((r,i)=>{
      const valor=Number(r[metrica]);
      const candidato=r.motivoNc??r.celulaNome??r.operadorNome;
      const rotulo=typeof candidato==='string'?candidato:'Resultado consolidado';
      return <div key={i} className="space-y-1.5"><div className="flex justify-between gap-3 text-sm"><span className="truncate" title={rotulo}>{rotulo}</span><span className="font-medium tabular-nums">{valor.toLocaleString('pt-BR',{maximumFractionDigits:2})}{metrica.endsWith('Pct')?'%':''}</span></div><div aria-hidden="true" className="h-2 rounded-full bg-muted overflow-hidden"><div className="h-full rounded-full bg-primary" style={{width:Math.max(0,Math.min(100,valor/teto*100))+'%'}} /></div></div>;
    })}</div>
  </figure>;
}
